<script>

import {axios} from '../../mixins';
import Modal from ".././Modal.vue"
import Tile from ".././Tile.vue"
import {Alerts} from "../../mixins/Alerts.js";
import ValidationIcon from "../ValidationIcon";
import ContractsSubmit from ".././Contracts/Submit.vue"
import FileManager from "./FileManager.vue";
import Comments from "../Comments.vue"
import MassUpdater from "../MassUpdater.vue";
import VueResizable from "vue-resizable";

export default {
  name: "UserDashboard.vue",

  components: {
    MassUpdater,
    FileManager,
    ValidationIcon,
    Tile,
    Modal,
    ContractsSubmit,
    Comments,
    VueResizable,
  },

  mixins: [
    axios
  ],

  props: {
    mapboxToken: {
      type: String,
      required: true,
    },
    esriToken: {
      type: String,
      required: true,
    },
    digifarmToken: {
      type: String,
      required: true,
    },
    operationTypes: {
      type: Object,
      required: true,
    },
    requiredOperations: {
      type: Object,
      required: true,
    },
    operationRelations: {
      type: Object,
      required: true,
    },
    additionalityTypes: {
      type: Object,
      required: false,
      default: [],
    },
    data: {
      type: Object,
      required: false,
    },
    primaryDataProp: {
      type: Object,
      required: false,
    },
    primaryDataKey: {
      type: Number,
      required: false,
    },
    secondaryDataKey: {
      type: Number,
      required: false,
    },
    secondaryDataProp: {
      type: Object,
      required: false
    },
    defaultUser: {
      type: Number,
      required: true
    },
    enrollmentQuestions: {
      type: Object,
      required: false
    },
    cropUseProp: {
      type: Object,
      required: false
    },
    instructionTexts: {
      type: Object,
      required: false
    },
    authUser: {
      type: Number,
      required: false,
      default: null,
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRecruiter: {
      type: Boolean,
      required: false,
      default: false,
    },
    // List of users for recruiters to manage
    users: {
      type: Array,
      required: false,
      default: []
    },
    // All user's contract years, including current enrollment
    years: {
      type: Array,
      required: false,
      default: []
    },
    // Current farm year
    year: {
      type: Number,
      required: false,
      default: 0,
    },
    // Enables/Disables "Add Farm"
    farmCreation: {
      type: Boolean,
      required: false,
      default: false
    },
    // Enables/Disables "Add field" and "Import Field(s)"
    fieldCreation: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Enables/Disables ContractSubmit component
    contractSubmission: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Enables/Disables only "Import Field(s)"
    deereIntegration: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Determines update tool status, if provided
    tool: {
      type: Number,
      required: false,
      default: null
    },
    // Controlled by tenant setting
    selectEnabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    llcName: {
      required: false,
      type: String,
      default: 'our program',
    }
  },

  data() {
    return {
      viewingMode: 'light-mode',
      indicatorOptions: [],
      primaryData: [],
      primaryDataIndex: 0,
      secondaryData: [],
      secondaryDataIndex: 0,
      activeTiles: [],
      heading: '',
      activeColor: '',
      createFarm: false,
      editFarm: false,
      farm: null,
      editField: false,
      field: null,
      alerts: new Alerts(),
      questionsData: null,
      cropUseData: null,
      boundaryError: false,
      fieldSearchQuery: '',
      filteredFields: {},
      excludedFields: {},
      showExcludedFields: false,
      copiedFieldYear: null,
      copiedField: null,
      cloningField: false,
      validateStatus: 0,
      yearFilter: null,
      userId: null,
      createFields: false,
      createFarms: false,
      offerEnrollment: false,
    };
  },

  created() {
    window.addEventListener("keydown", this.keyListener);

    // Set props to reactive data
    this.userId = this.defaultUser
    this.yearFilter = this.year
    this.primaryData = this.primaryDataProp
    this.secondaryData = this.secondaryDataProp
    this.questionsData = this.enrollmentQuestions
    this.cropUseData = this.cropUseProp
    // Assign prop to data field to update perms during farm switching
    this.createFields = this.fieldCreation
    this.createFarms = this.farmCreation
    if (!this.primaryData) {
      // Show instruction text
    } else {
      this.getData(this.primaryDataKey, null, this.secondaryDataKey)
    }
  },

  mounted() {
    this.viewingMode = localStorage.getItem('darkMode') ? 'dark-mode' : 'light-mode';

    // Listen to resizing to reset resizable list when crossing screen size thresholds
    // Resize will get called for continuous movement. resizeEnd might be a replacement
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    fieldSearchQuery(query) {
      this.queryFields(query)
    }
  },

  methods: {
    keyListener(event) {
      if (event.key === "r" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault(); // prevent default action from getting triggered.
        let data = {
          user_id: this.userId,
          farm_id: this.primaryDataIndex,
        }
        if (this.secondaryDataIndex > 0) {
          data.field_id = this.secondaryDataIndex
        }

        location.href = '?' + this.urlParams(data)
      }
    },

    getFarms() {
      if (this.yearFilter) {
        this.get('' + this.userId + '/farms?year=' + this.yearFilter).then((response) => {
          this.primaryData = response.data.farms;
          this.primaryDataIndex = Object.keys(this.primaryData)[0]
          this.createFarms = response.data.farmCreation

          this.$refs["file-manager"].selectedYear = this.yearFilter

          this.getData(this.primaryDataIndex)
        });
      }
    },

    getData(id, index, secondaryId) {
      id = id ?? this.primaryDataKey

      this.clearEditors()
      let urlParams = ''
      if (this.userId) {
        urlParams = this.urlParams({user_id: this.userId, farm_id: id})
      }

      this.get('/content/' + id + '?' + urlParams).then((response) => {
        // Set indexing
        this.secondaryDataIndex = null;
        this.primaryDataIndex = id;
        // Set URL
        history.replaceState({}, '', '?user_id=' + this.userId + '&farm_id=' + this.primaryDataIndex)

        this.heading = this.primaryData[this.primaryDataIndex];
        // Only need object.values for finding index on initial load
        this.activeColor = this.getColor(index ?? Object.values(this.primaryData).indexOf(this.primaryData[this.primaryDataIndex]))

        // Get response data
        this.farm = response.data.farm
        this.indicatorOptions = response.data.indicatorOptions;
        this.defaultUnits = response.data.defaultUnits;
        this.secondaryData = response.data.secondaryData;
        this.questionsData = response.data.questionsData;
        this.cropUseData = response.data.cropUseData;
        this.createFields = response.data.fieldCreation;
        this.offerEnrollment = response.data.offerEnrollment;

        // Apply empty query to populate field list
        this.queryFields(null)

        // Use next tick so data actually clears
        this.activeTiles = false;
        if (secondaryId > 0) {
          this.getSecondaryData(secondaryId)
        } else {
          this.$nextTick(function () {
          this.activeTiles = response.data.tiles;
        })
        }
      })
    },

    getSecondaryData(id) {
      this.clearEditors()
      if (id > 0)
      {
        let urlParams = ''
        if (this.userId) {
          urlParams = this.urlParams({user_id: this.userId, farm_id: this.primaryDataIndex, field_id: id})
        }

        this.get('/contentSecondary/' + id + '?' + urlParams).then((response) => {
          this.secondaryDataIndex = id;
          // Set URL
          history.replaceState({}, '', '?user_id=' + this.userId + '&farm_id=' + this.primaryDataIndex + '&field_id=' + this.secondaryDataIndex)

          // Use next tick so data actually clears
          this.activeTiles = [];
          this.$nextTick(function () {
            this.activeTiles = response.data.tiles;
            this.field = response.data.field;
          })
        });
      } else {
        // Without an ID, fallback to the farm view
        this.getData(this.primaryDataIndex)
      }
      this.heading = this.primaryData[this.primaryDataIndex];
    },

    queryFields() {
      this.filteredFields = {}
      this.excludedFields = {}
      for (let [key, data] of Object.entries(this.secondaryData)) {
        if ((data['name'].toLowerCase()).includes(this.fieldSearchQuery.toLowerCase())) {
          if (data['is_included']) {
            this.filteredFields[key] = data
          } else {
            this.excludedFields[key] = data
          }
        }
      }
    },

    toggleExcludedFields() {
      this.showExcludedFields = !this.showExcludedFields
    },

    openFarmForm(farm) {
      this.clearEditors()
      this.secondaryDataIndex = 0;
      this.activeTiles = [];
      // If there is no farm selected, show creation form
      if (!farm) {
        this.secondaryData = [];
        this.queryFields();
        this.primaryDataIndex = null;
        this.secondaryDataIndex = 0;
        this.primaryDataIndex = -1
        this.createFarm = true;
        this.heading = 'Create a Farm'
      } else {
        this.editFarm = true;
      }
    },

    openFieldForm(create) {
      this.clearEditors()

      // Allow a tick to pass so editors are cleared. Prevents data issues when quick switching.
      this.$nextTick(function () {
        if (create) {
          this.secondaryDataIndex = -1;
          this.field = null
        }

        // Load data if field selected
        if (this.secondaryDataIndex && !create) {
          this.get('fields/' + this.secondaryDataIndex).then((response) => {
            this.field = response.data.resource
          })
        }
        // Otherwise, create an empty field
        this.field = this.field ?? {
          'id': null,
          'farmBoundary': this.farm.boundary,
          'ipm_principles_used': null,
          'has_tile_drainage': 'Unsure',
          'farm_id': this.farm.id,
          'type': 'fields',
          'field_type': null,
        };
        this.heading = this.field.name ?? 'Create Field'
        this.activeTiles = [];
        this.editField = true;
      })
    },

    getField(id) {
      this.get('fields/' + id).then((response) => {
        this.field = response.data.resource;
      })
    },

    updateResource(resource, type) {
      this.alerts.initialize()
      resource.type = resource.type ?? type;
      this.patch(resource.type + '/' + resource.id, resource.data).then((response) => {
        this.clearEditors()
        if (resource.type === 'fields') {
          this.$refs['fieldsForm'].submitting = false;
          this.secondaryData[this.field.id].name = this.field.name;

          // Use "getField" to avoid flipped Lat/Lng from response
          this.getField(this.field.id)
          this.getSecondaryData(this.field.id);
          this.queryFields(this.fieldSearchQuery ?? '')
        } else {
          this.farm = response.data.resource;
          this.primaryData[this.farm.id] = this.farm.name;
          this.getData(this.farm.id);
        }
      }).catch((errors) => {
        this.$refs['fieldsForm'].submitting = false;
        this.alerts.recordErrors(errors.response.data.errors)
      });
    },

    storeResource(resource, type) {
      this.alerts.initialize()
      resource.type = resource.type ?? type;
      if (resource.type) {
        this.post(resource.type, resource.data).then((response) => {
          this.clearEditors()
          if (resource.type === 'fields') {
            this.filteredFields[response.data.resource.id] = {
              id: response.data.resource.id,
              name: response.data.resource.name,
              is_included: true,
              type: 'fields'
            }
            this.getSecondaryData(response.data.resource.id)
          } else {
            this.getData(this.farm.id)
          }
        }).catch((errors) => {
          this.alerts.recordErrors(errors.response.data.errors)
          if (resource.type === 'fields' && this.alerts.getError('boundary')) {
            this.boundaryError = true;
          }
        });
      }
    },

    deleteResource(resource) {
      this.alerts.initialize()
      this.delete(resource.type + '/' + resource.id).then(() => {
        if (resource.type === 'farms') {
          location.href = '?' + 'user_id=' + this.userId
        } else {
          this.getData(this.primaryDataIndex)
        }
      })
    },

    showResource(type, id) {
      if (type !== 'farms') {
        this.getSecondaryData(id)
      }
    },

    validateResource(resource) {
      let messages
      let isValid = false
      this.get('/validate/' + resource.type + '/' + resource.id).then((response) => {
        messages = response.data.errors
        if (messages.length === 0) {
          messages = [['Data is valid.']]
          isValid = true
        }

        let refResource = this.$refs[resource.type + `-` + resource.id]
        if (refResource) {
          if (Array.isArray(refResource)) {
            refResource = refResource[0]
          }
          refResource.setMessages(messages)
        }

        if (resource.type === 'fields') {
          this.filteredFields[resource.id].is_valid = isValid
        }
      }).catch((errors) => {
        messages = [errors]

        let refResource = this.$refs[resource.type + `-` + resource.id]
        if (Array.isArray(refResource)) {
          refResource = refResource[0]
        }
        refResource.setMessages(messages)

        if (resource.type === 'fields') {
          this.filteredFields[resource.id].is_valid = isValid
        }
      });
    },

    validateAll() {
      this.validateStatus = 1;

      this.get('/validate?farm_id=' + this.farm.id + '&user_id=' + this.userId).then(() => {
        this.validateStatus = 0;
        location.reload()
      }).catch(() => {
        this.validateStatus = 2
      })
    },

    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key)) {
          out.push(key + '=' + encodeURIComponent(myData[key]));
        }
      }
      return out.join('&');
    },

    isActivePrimary(id, returnData, returnFalse) {
      if (id === this.primaryDataIndex) {
        return returnData
      }

      // Return alternative data
      return returnFalse;
    },

    getColor(index) {
      switch (index % 3) {
        default:
        case 0:
          return 'swof-yellow'
        case 1:
          return 'swof-green'
        case 2:
          return 'swof-blue'
      }
    },

    isActiveSecondary(id, returnData) {
      if (id === this.secondaryDataIndex) {
        return returnData
      }
    },

    clearEditors() {
      this.createFarm = false;
      this.editFarm = false;
      this.editField = false;
    },

    copyFieldYear(fieldYear) {
      this.clearCopiedData()
      this.copiedFieldYear = fieldYear;
    },

    clearCopiedData() {
      this.copiedFieldYear = null;
      this.copiedField = null;
    },

    copyField() {
      this.clearCopiedData();
      this.copiedField = this.secondaryDataIndex
    },

    // Clone entire field's operations to another field
    cloneAllOperations() {
      this.cloningField = true;
      this.alerts.initialize();

      let data = {
        field_id: this.copiedField,
        destination_field: this.secondaryDataIndex,
      }

      this.post('fields/clone', data).then((response) => {
        if (response.data.status === "failed") {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.getSecondaryData(this.secondaryDataIndex)
        }

        this.cloningField = false;
        this.scrollCarouselToYear()
        this.validateResource({id: this.secondaryDataIndex, type: 'fields'})
      }).catch(() => {
        this.cloning = false
      })
    },

    onResize() {
      // Tailwind lg screen size = 1024
      // If window size is smaller, reset resizable components
      if (window.innerWidth < 1024) {
        this.$refs['resizable-index'].h = null;
        this.$refs['resizable-index'].w = null;
      }
    },
  }
}
</script>

<template>
  <div :class="viewingMode" class="flex flex-col lg:flex-row h-full max-h-[90dvh]">
    <!-- DATA AND SUB-LEVEL DATA INDEX -->
    <vue-resizable
        ref="resizable-index"
        minWidth="150"
        maxWidth="600"
        active="['r']"
        fitParent="true"
        height="auto"
        class="lg:w-1/6 w-full flex-none bg-primary flex flex-col h-full resizable-handle resizable-handle-right">
      <div v-show="this.isRecruiter" class="w-full">
        <select name="user"
                id="user"
                v-model="this.userId"
                @change="this.getFarms"
                class="w-full bg-secondary italic border-b border-grey-light px-2 py-1 leading-tight focus:outline-none focus:ring">
          <option :value="this.authUser">All Users</option>
          <template v-for="(name, id) in this.users">
            <option :value="id">{{ name }}</option>
          </template>
        </select>
      </div>

      <div class="flex flex-col lg:flex-row h-full overflow-scroll">
        <!-- FARMS -->
        <div class="lg:w-[40%] lg:h-max lg:flex lg:flex-col justify-start">
          <div class="lg:w-auto lg:border-b border-grey-lightest">
            <div class="text-lg font-semibold text-grey p-2 flex justify-between">
              <span>Farms</span>
            </div>

            <div class="px-1 pb-1 h-8 lg:w-full text-grey">
              <select name="year"
                      id="year"
                      v-model="this.yearFilter"
                      @change="this.getFarms"
                      class="w-full bg-secondary italic border-b border-grey-light px-2 py-1 rounded-md leading-tight focus:outline-none focus:ring">
                <option :value="null">Year</option>
                <template v-for="(year) in this.years">
                  <option :value="year">{{ year }}</option>
                </template>
              </select>
            </div>
          </div>

          <div class="lg:overflow-y-auto lg:overflow-x-hidden w-full whitespace-nowrap overflow-x-scroll lg:whitespace-normal lg:block">
            <template v-for="(item, id, index) in this.primaryData">
              <div class="text-center py-2 px-1 cursor-pointer inline-block lg:block" :class="isActivePrimary(id, 'bg-secondary')" @click="this.getData(id, index)">
                <div class="rounded-full p-1 mx-auto" :class="'bg-'+getColor(index) + ' ' + isActivePrimary(id, 'w-12', 'w-8')">
                  <i class="block far fa-farm mx-auto"></i>
                </div>
                {{ item }}
              </div>
            </template>
            <div v-if="this.createFarms"
                 class="text-center py-2 px-1 cursor-pointer inline-block lg:block"
                 :class="isActivePrimary(-1, 'bg-secondary')"
                 @click="this.openFarmForm(null)">
              <div class="mx-auto text-2xl text-blue">
                <i class="block fas fa-plus-circle mx-auto"></i>
              </div>
              <span>Add Farm</span>
            </div>
          </div>
        </div>

        <!-- FIELDS -->
        <div class="bg-secondary lg:w-[60%] lg:h-max flex flex-col justify-start">
          <div class="lg:border-b border-grey-lightest flex lg:block items-center">
            <div class="text-lg font-semibold text-grey p-1 lg:p-2 flex justify-between">
              <span>Fields</span>
            </div>

            <div class="px-1 p-1 lg:pb-1 h-8 w-full flex text-grey">
              <span class="text-sm my-auto mr-1">
                <i class="fas fa-magnifying-glass"></i>
              </span>
              <input type="text"
                     placeholder="Search..."
                     v-model="this.fieldSearchQuery"
                     class="rounded w-full">
            </div>
          </div>

          <div class="overflow-x-scroll whitespace-nowrap py-1 lg:py-0 lg:block lg:overflow-y-auto lg:overflow-x-hidden">
            <div v-if="Object.entries(this.filteredFields).length === 0"
                 class="text-center italic">
              No Fields
            </div>

            <template v-for="(item) in this.filteredFields">
              <div class="p-1 text-sm cursor-pointer inline-block lg:flex justify-start whitespace-normal lg:max-w-none lg:border-b border-grey-lightest"
                   :class="this.isActiveSecondary(item.id, 'text-white bg-'+this.activeColor)"
                   @click="this.getSecondaryData(item.id)">
                <div class="flex">
                  <div class="my-auto w-4 pr-2 text-center">
                    <span v-show="item.is_valid && !item.has_warning" class="text-green" :class="this.isActiveSecondary(item.id, '!text-white')">
                      <i class="fas fa-check-circle"></i>
                    </span>
                    <span v-show="item.is_valid && item.has_warning" class="text-yellow-dark" :class="this.isActiveSecondary(item.id, '!text-white')">
                      <i class="fas fa-warning"></i>
                    </span>
                    <span v-show="!item.is_valid" class="text-red" :class="this.isActiveSecondary(item.id, '!text-white')">
                      <i class="fas fa-exclamation-circle"></i>
                    </span>
                  </div>

                  <div class="my-auto">
                    {{ item.name }}
                  </div>
                </div>
                <span v-if="item.is_included_add"
                      class="my-auto ml-auto font-bold italic font-mono text-blue"
                >
                  {{ item.addName }}
                </span>
              </div>
            </template>
          </div>

          <div>
            <div class="flex lg:block justify-center">
              <div class="lg:mt-2 lg:pl-2 text-sm cursor-pointer flex justify-center"
                   @click="this.openFieldForm(true)"
                   :class="this.isActiveSecondary(-1, 'text-'+this.activeColor+' border-l-4 border-'+this.activeColor)"
                   v-if="this.primaryDataIndex > 0 && this.createFields">
                <span class="text-2xl text-blue my-auto">
                  <i class="fas fa-circle-plus"></i>
                </span>
                <span class="p-2">Add Field</span>
              </div>

              <a :href="`farms/`+ this.primaryDataIndex +`/precision-ag`"
                 class="lg:mt-2 lg:pl-2 text-sm cursor-pointer flex justify-center"
                 v-if="this.primaryDataIndex > 0 && this.createFields && this.deereIntegration">
                <span class="text-xl text-blue my-auto">
                    <i class="fas fa-external-link"></i>
                </span>
                <span class="p-2">Import Field(s)</span>
              </a>
            </div>
          </div>

          <div v-if="Object.entries(this.excludedFields).length > 0" class="mt-auto bg-quarternary">
            <div class="text-sm p-2 flex justify-between" @click="toggleExcludedFields()">
              <span>Excluded Fields</span>
              <span v-if="!this.showExcludedFields" class="my-auto"><i class="far fa-chevron-up"></i></span>
              <span v-else class="my-auto"><i class="far fa-chevron-down"></i></span>
            </div>
            <div v-if="this.showExcludedFields" class="max-h-[24rem] overflow-x-scroll">
              <template v-for="(item) in this.excludedFields">
                <div class="text-left py-2 px-2 text-sm cursor-pointer"
                     :class="this.isActiveSecondary(item.id, 'text-'+this.activeColor+' border-l-4 border-'+this.activeColor)"
                     @click="this.getSecondaryData(item.id)">
                  {{ item.name }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </vue-resizable>

    <!-- MAIN -->
    <!-- Display all active tiles -->
    <div class="bg-tertiary w-full lg:pr-2 lg:pl-1 pt-2 flex flex-col overflow-auto">
      <div class="flex flex-col lg:flex-row justify-between lg:pr-2">
        <div class="flex flex-col lg:flex-row">
          <h1 class="text-xl px-2">
            {{ this.heading }}
          </h1>
          <div class="lg:w-auto mx-auto lg:mx-2 cursor-pointer text-sm text-blue">
            <div v-show="this.editFarm || this.editField || this.createFarm"
                 @click="(this.editFarm || this.createFarm)
                 ? getData((this.primaryDataIndex > 0) ? this.primaryDataIndex : this.primaryDataKey)
                 : getSecondaryData(this.secondaryDataIndex)"
                 class="button bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter">
              <span><i class="fal fa-square-xmark"></i></span>
              <span class="pl-1">Close</span>
            </div>
            <div v-show="(!this.createFarm && !this.editFarm && !this.editField && this.farm)" @click="openFarmForm(this.farm)"
                 class="button bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter">
              <span><i class="fas fa-pen-to-square"></i></span>
              <span class="pl-1">Edit Farm</span>
            </div>
          </div>
        </div>

        <div v-if="this.farm && !this.createFarm" class="flex flex-col items-center lg:items-start lg:flex-row my-2 lg:my-0 gap-2">
          <!-- COMMENT MODAL -->
          <div v-if="this.isAdmin" class="mx-auto">
            <button class="button bg-primary border-blue text-blue w-full"
                    @click="this.$refs['commentsModal'].setData(this.farm.id, this.farm.name, '', 'farm_id');"
                    type="button">
              <span>
                <i class="fas fa-comment"/> Notes
              </span>
            </button>
            <Comments ref="commentsModal">
            </Comments>
          </div>

          <div v-if="this.isAdmin" class="mx-auto">
            <button class="button bg-primary border-blue text-blue"
                    @click="this.validateAll()"
                    type="button">
              <span v-show="this.validateStatus === 0"><i class="fas fa-check"/> Validate Farm</span>
              <span v-show="this.validateStatus === 1"><i class="fas fa-spinner-third fa-spin"/> Validating...</span>
              <span v-show="this.validateStatus === 2"><i class="fas fa-xmark-circle"/> Error!</span>
            </button>
          </div>

          <MassUpdater
            class="mx-auto"
            :indicator-options="this.indicatorOptions"
            :farm-id="this.farm.id"
            :default-type="tool"
            :default-year="2026"
          >
          </MassUpdater>

          <FileManager class="mx-auto"
            :locked="!this.farm.allows_uploads"
            :farm="this.farm"
            :name="this.heading"
            :user-id="this.userId"
            :years="this.years"
            :year="this.year"
            ref="file-manager"
          >
          </FileManager>

          <ContractsSubmit
            class="mx-auto"
            :userId="this.userId" :farmId="this.farm.id"
            :disabled="this.farm.submitDisabled"
            :orgName="this.farm.orgName"
            @show="showResource"
            @submitted="this.farm.is_locked = true"
            v-if="(!this.farm.contractStatus || this.farm.contractStatus < 4) && this.contractSubmission"
          >
          </ContractsSubmit>

          <div v-if="this.farm.contractStatus === 4">
            <button class="button button-wide text-white bg-blue hover:bg-blue-dark focus:bg-blue-darker font-bold">
              <a :href="`/contracts/` + this.farm.contractId + `/estimate`" target="_self">
                <i class="fas fa-file-contract mr-1"></i> Review Offer
              </a>
            </button>
          </div>

          <div v-if="this.farm.contractStatus === 5">
            <button class="button button-wide text-white bg-blue hover:bg-blue-dark focus:bg-blue-darker font-bold">
              <a :href="`/contracts/` + this.farm.contractId + `/sign`" target="_self">
                <i class="fas fa-file-contract mr-1"></i> Review Contract & Sign</a>
            </button>
          </div>
        </div>
      </div>

      <div v-if="this.activeTiles" class="grid grid-cols-12 mb-4">
        <div v-if="this.offerEnrollment" class="col-span-12">
          <div class="col-span-12 p-2 m-2 tile-shadow bg-primary rounded">
            <re-enrollment-prompt :is-admin="this.isAdmin"
                                  :user-id="this.userId"
                                  :llc-name="this.llcName"
                                  :farm-name="this.farm.name"
                                  :farm-id="this.farm.id"
            ></re-enrollment-prompt>
          </div>
        </div>

        <template v-for="tile in this.activeTiles">
          <tile :data="tile"
                :options="this.indicatorOptions"
                :defaultUnits="this.defaultUnits"
                :mapbox-token="this.mapboxToken"
                :esri-token="this.esriToken"
                :operation-types="this.operationTypes"
                :required-operations="this.requiredOperations"
                :additionality-types="this.additionalityTypes"
                :copied-field-year-data="this.copiedFieldYear"
                :copied-field-data="this.copiedField ?? false"
                :user-id="this.userId"
                :farm-id="this.farm.id"
                :field-id="this.secondaryDataIndex"
                :locked="this.farm.is_locked"
                @openFieldForm="this.openFieldForm(false)"
                @copyFieldYear="this.copyFieldYear"
                @clearCopiedData="this.clearCopiedData"
                @copyField="this.copyField()"
                @pasteField="this.cloneAllOperations()"
                @show="this.showResource"
                @validateResource="this.validateResource"
          >
          </tile>
        </template>
      </div>

      <div v-if="!this.farm && !this.createFarm">
        <div class="bg-primary tile-shadow rounded m-1 p-2">
          <div v-html="this.instructionTexts[69]['value']">
          </div>
        </div>
      </div>

      <div v-if="this.createFarm" class="bg-primary tile-shadow rounded m-1 w-1/2 mx-auto">
        <farms-create :questions-data="this.questionsData"
                      :crop-use-data="this.cropUseData"
                      :mapbox-token="this.mapboxToken"
                      :esri-token="this.esriToken"
                      :user-id="this.userId"
                      :alerts="this.alerts"
                      @getData="getData">
        </farms-create>
      </div>

      <div v-if="this.editFarm" class="bg-primary tile-shadow rounded m-1">
        <farms-form :resource="{'data':this.farm, 'id':this.farm.id}"
                    :mapbox-token="this.mapboxToken"
                    :esri-token="this.esriToken"
                    :alerts="this.alerts"
                    :questions-data="this.questionsData"
                    :crop-use-data="this.cropUseData"
                    :locked="this.farm.is_locked"
                    @store="storeResource"
                    @update="updateResource"
                    @delete="deleteResource"
                    @getData="getData">
        </farms-form>
      </div>

      <div v-if="this.editField" class="bg-primary tile-shadow rounded m-1">
        <fields-form ref="fieldsForm"
                     :resource="this.field ?? {'data':[]}"
                     :farmBoundaries="this.field.farmBoundary"
                     :farmAddress="this.farm.address"
                     :farmId="this.primaryDataIndex"
                     :zipCode="this.farm.zipcode"
                     :mapboxToken="mapboxToken"
                     :esri-token="this.esriToken"
                     :digifarmToken="digifarmToken"
                     :options="this.indicatorOptions"
                     :alerts="this.alerts"
                     :boundaryError="this.boundaryError"
                     :locked="this.farm.is_locked"
                     :selectEnabled="this.selectEnabled"
                     @store="storeResource"
                     @update="updateResource"
                     @delete="deleteResource">
        </fields-form>
      </div>
    </div>
  </div>
</template>
